import {
  ActiveFeatureFlags,
  CustomAttribute,
  DefaultFilters,
} from '@accredible-frontend-v2/models';
import { AccredibleRecipientFeatureFlagsService } from '@accredible-frontend-v2/services/recipient-feature-flags';
import {
  AccredibleResponsiveBreakpoint,
  AccredibleResponsiveHelper,
} from '@accredible-frontend-v2/utils/responsive-helper';
import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  inject,
  input,
  output,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { SpotlightProfilesFilters } from '../../../../core/models/spotlight-profiles.model';
import { FilterService } from '../../services/filter.service';
import { SpotlightProfilesActions } from '../../store/spotlight-profiles/spotlight-profiles.actions';
import { SpotlightProfilesState } from '../../store/spotlight-profiles/spotlight-profiles.reducer';

@Component({
  selector: 'sl-profile-list-filters',
  templateUrl: './profile-list-filters.component.html',
  styleUrls: ['./profile-list-filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileListFiltersComponent {
  private readonly _spotlightProfileStore = inject(Store<SpotlightProfilesState>);
  private readonly _filter = inject(FilterService);

  menuOpen = input(false);
  filters = input<SpotlightProfilesFilters>();
  directoryFilters = input<DefaultFilters>();
  directoryCustomAttributeFilters = input<CustomAttribute[]>();
  showDefaultFilters = input(false);
  isInitialLoad = input(true);

  hideFilters = output<boolean>();

  readonly hasFiltersApplied$ = this._filter.hasFiltersApplied$;

  isDesktop: boolean;

  @HostListener('window:resize')
  onResize(): void {
    this.isDesktop = AccredibleResponsiveHelper.isScreenGreaterThan(
      AccredibleResponsiveBreakpoint.MD,
    );
  }

  onClearFilters(): void {
    // Clear state
    this._spotlightProfileStore.dispatch(SpotlightProfilesActions.clearFilters());

    const filtersToClear = {
      page: null,
      name: null,
      search_by: null,
      search_term: null,
      order: null,
      groups: null,
      location: null,
      city: null,
      custom_location_distance: null,
      country: null,
      state: null,
      skills: null,
      availability: null,
      organizations: null,
      categories: null,
      radius: null,
    };

    // Add the customAttribute ids to the filters to be cleared
    this.directoryCustomAttributeFilters().forEach((customAttribute) => {
      filtersToClear[customAttribute.id] = null;
    });

    // Clear query params
    this._filter.updateRouterQueryParams(filtersToClear);
  }

  onFilterMenuClose(): void {
    this.hideFilters.emit(true);
  }
}
